import { FeatureFlagsActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { setFeatureFlags } from './actions'
import { FeatureFlagsState } from './types'

export const initialState: FeatureFlagsState = {}

export const featureFlagsReducer = (
  state = initialState,
  action: FeatureFlagsActions
): FeatureFlagsState => {
  switch (action.type) {
    case getType(setFeatureFlags): {
      return {
        ...state,
        ...action.payload,
      }
    }
    default:
      return state
  }
}

export default featureFlagsReducer



// WEBPACK FOOTER //
// ./src/state/featureFlags/reducer.ts